/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.7.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { getAuth0Token, getVectorBaseUrl, transformApiResult, transformRequestOptions } from './VectorClientHelpers';
export class VectorClientBase { 

    protected transformOptions(options: any) {
        return this.getToken().then(newToken => transformRequestOptions(newToken, options));
      }
  
  protected transformResult(url: string, response: Response, processor: (response: Response) => any) {
    return transformApiResult(url, response, processor);
  }

  protected getBaseUrl(urlTemplate: string, defaultUrl: string | undefined): string {
    return getVectorBaseUrl(urlTemplate, defaultUrl);
  }

  private async getToken() {
    return getAuth0Token();
  }
}

export interface IBookmarksClient {
    /**
     * @return Success
     */
    groupsAll(vaultId: number, sectionId: number): Promise<GroupApiModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    groupsPOST(vaultId: number, sectionId: number, body?: GroupCreationRequest | undefined): Promise<GroupApiModel>;
    /**
     * @return Success
     */
    groupsGET(vaultId: number, sectionId: number, groupId: number): Promise<GroupApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    groupsPUT(vaultId: number, sectionId: number, groupId: number, body?: GroupUpdateRequest | undefined): Promise<GroupApiModel>;
    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    groupsDELETE(vaultId: number, sectionId: number, groupId: number, shouldDelete?: boolean | undefined): Promise<void>;
    /**
     * @return Success
     */
    resourcesAll(vaultId: number, sectionId: number, groupId: number): Promise<ResourceApiModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    verify(vaultId: number, body?: UrlVerificationRequest | undefined): Promise<VerificationResultApiModel>;
    /**
     * @return Success
     */
    resourcesAll2(vaultId: number, urlHash: string): Promise<ResourceApiModel[]>;
    /**
     * @return Success
     */
    resourcesGET(vaultId: number, sectionId: number, groupId: number, resourceId: number): Promise<ResourceApiModel>;
    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    resourcesDELETE(vaultId: number, sectionId: number, groupId: number, resourceId: number, shouldDelete?: boolean | undefined): Promise<ResourceApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resourcesPUT(vaultId: number, resourceId: number, body?: ResourceUpdateRequest | undefined): Promise<ResourceApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    resourcesPOST(vaultId: number, body?: ResourceCreationRequest | undefined): Promise<ResourceApiModel>;
    /**
     * @return Success
     */
    sectionsAll(vaultId: number): Promise<SectionApiModel[]>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sectionsPOST(vaultId: number, body?: SectionCreationRequest | undefined): Promise<SectionApiModel>;
    /**
     * @return Success
     */
    sectionsGET(vaultId: number, sectionId: number): Promise<SectionApiModel>;
    /**
     * @param body (optional) 
     * @return Success
     */
    sectionsPUT(vaultId: number, sectionId: number, body?: SectionUpdateRequest | undefined): Promise<SectionApiModel>;
    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    sectionsDELETE(vaultId: number, sectionId: number, shouldDelete?: boolean | undefined): Promise<SectionApiModel>;
}

export class BookmarksClient extends VectorClientBase implements IBookmarksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * @return Success
     */
    groupsAll(vaultId: number, sectionId: number): Promise<GroupApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/sections/{sectionId}/Groups";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGroupsAll(_response));
        });
    }

    protected processGroupsAll(response: Response): Promise<GroupApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GroupApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupApiModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    groupsPOST(vaultId: number, sectionId: number, body?: GroupCreationRequest | undefined): Promise<GroupApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/sections/{sectionId}/Groups";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGroupsPOST(_response));
        });
    }

    protected processGroupsPOST(response: Response): Promise<GroupApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    groupsGET(vaultId: number, sectionId: number, groupId: number): Promise<GroupApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/sections/{sectionId}/Groups/{groupId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGroupsGET(_response));
        });
    }

    protected processGroupsGET(response: Response): Promise<GroupApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    groupsPUT(vaultId: number, sectionId: number, groupId: number, body?: GroupUpdateRequest | undefined): Promise<GroupApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/sections/{sectionId}/Groups/{groupId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGroupsPUT(_response));
        });
    }

    protected processGroupsPUT(response: Response): Promise<GroupApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupApiModel>(<any>null);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    groupsDELETE(vaultId: number, sectionId: number, groupId: number, shouldDelete?: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/sections/{sectionId}/Groups/{groupId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGroupsDELETE(_response));
        });
    }

    protected processGroupsDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    resourcesAll(vaultId: number, sectionId: number, groupId: number): Promise<ResourceApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/sections/{sectionId}/groups/{groupId}/Resources";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResourcesAll(_response));
        });
    }

    protected processResourcesAll(response: Response): Promise<ResourceApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceApiModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verify(vaultId: number, body?: UrlVerificationRequest | undefined): Promise<VerificationResultApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Resources/verify";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVerify(_response));
        });
    }

    protected processVerify(response: Response): Promise<VerificationResultApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerificationResultApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerificationResultApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    resourcesAll2(vaultId: number, urlHash: string): Promise<ResourceApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Resources/{urlHash}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (urlHash === undefined || urlHash === null)
            throw new Error("The parameter 'urlHash' must be defined.");
        url_ = url_.replace("{urlHash}", encodeURIComponent("" + urlHash));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResourcesAll2(_response));
        });
    }

    protected processResourcesAll2(response: Response): Promise<ResourceApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ResourceApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceApiModel[]>(<any>null);
    }

    /**
     * @return Success
     */
    resourcesGET(vaultId: number, sectionId: number, groupId: number, resourceId: number): Promise<ResourceApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/sections/{sectionId}/groups/{groupId}/Resources/{resourceId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResourcesGET(_response));
        });
    }

    protected processResourcesGET(response: Response): Promise<ResourceApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceApiModel>(<any>null);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    resourcesDELETE(vaultId: number, sectionId: number, groupId: number, resourceId: number, shouldDelete?: boolean | undefined): Promise<ResourceApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/sections/{sectionId}/groups/{groupId}/Resources/{resourceId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResourcesDELETE(_response));
        });
    }

    protected processResourcesDELETE(response: Response): Promise<ResourceApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resourcesPUT(vaultId: number, resourceId: number, body?: ResourceUpdateRequest | undefined): Promise<ResourceApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Resources/{resourceId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (resourceId === undefined || resourceId === null)
            throw new Error("The parameter 'resourceId' must be defined.");
        url_ = url_.replace("{resourceId}", encodeURIComponent("" + resourceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResourcesPUT(_response));
        });
    }

    protected processResourcesPUT(response: Response): Promise<ResourceApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resourcesPOST(vaultId: number, body?: ResourceCreationRequest | undefined): Promise<ResourceApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Resources";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResourcesPOST(_response));
        });
    }

    protected processResourcesPOST(response: Response): Promise<ResourceApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResourceApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResourceApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    sectionsAll(vaultId: number): Promise<SectionApiModel[]> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Sections";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSectionsAll(_response));
        });
    }

    protected processSectionsAll(response: Response): Promise<SectionApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SectionApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionApiModel[]>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sectionsPOST(vaultId: number, body?: SectionCreationRequest | undefined): Promise<SectionApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Sections";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSectionsPOST(_response));
        });
    }

    protected processSectionsPOST(response: Response): Promise<SectionApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionApiModel>(<any>null);
    }

    /**
     * @return Success
     */
    sectionsGET(vaultId: number, sectionId: number): Promise<SectionApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Sections/{sectionId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSectionsGET(_response));
        });
    }

    protected processSectionsGET(response: Response): Promise<SectionApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionApiModel>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sectionsPUT(vaultId: number, sectionId: number, body?: SectionUpdateRequest | undefined): Promise<SectionApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Sections/{sectionId}";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSectionsPUT(_response));
        });
    }

    protected processSectionsPUT(response: Response): Promise<SectionApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionApiModel>(<any>null);
    }

    /**
     * @param shouldDelete (optional) 
     * @return Success
     */
    sectionsDELETE(vaultId: number, sectionId: number, shouldDelete?: boolean | undefined): Promise<SectionApiModel> {
        let url_ = this.baseUrl + "/api/apps/knowledgebase/{vaultId}/Sections/{sectionId}?";
        if (vaultId === undefined || vaultId === null)
            throw new Error("The parameter 'vaultId' must be defined.");
        url_ = url_.replace("{vaultId}", encodeURIComponent("" + vaultId));
        if (sectionId === undefined || sectionId === null)
            throw new Error("The parameter 'sectionId' must be defined.");
        url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
        if (shouldDelete === null)
            throw new Error("The parameter 'shouldDelete' cannot be null.");
        else if (shouldDelete !== undefined)
            url_ += "shouldDelete=" + encodeURIComponent("" + shouldDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSectionsDELETE(_response));
        });
    }

    protected processSectionsDELETE(response: Response): Promise<SectionApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SectionApiModel>(<any>null);
    }
}

export class GroupApiModel implements IGroupApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    name?: string | undefined;
    resourceCount?: number;
    resources?: ResourceApiModel[] | undefined;

    constructor(data?: IGroupApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.resources) {
                this.resources = [];
                for (let i = 0; i < data.resources.length; i++) {
                    let item = data.resources[i];
                    this.resources[i] = item && !(<any>item).toJSON ? new ResourceApiModel(item) : <ResourceApiModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.name = _data["name"];
            this.resourceCount = _data["resourceCount"];
            if (Array.isArray(_data["resources"])) {
                this.resources = [] as any;
                for (let item of _data["resources"])
                    this.resources!.push(ResourceApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new GroupApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["name"] = this.name;
        data["resourceCount"] = this.resourceCount;
        if (Array.isArray(this.resources)) {
            data["resources"] = [];
            for (let item of this.resources)
                data["resources"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IGroupApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    name?: string | undefined;
    resourceCount?: number;
    resources?: IResourceApiModel[] | undefined;
}

export class GroupCreationRequest implements IGroupCreationRequest {
    name!: string;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IGroupCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): GroupCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GroupCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IGroupCreationRequest {
    name: string;
    legacyKnowledgebaseId?: string | undefined;
}

export class GroupUpdateRequest implements IGroupUpdateRequest {
    newParentId!: number;
    newName!: string;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IGroupUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.newName = _data["newName"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): GroupUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GroupUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["newName"] = this.newName;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IGroupUpdateRequest {
    newParentId: number;
    newName: string;
    legacyKnowledgebaseId?: string | undefined;
}

export class ResourceApiModel implements IResourceApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    classification?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    thumbnail?: string | undefined;
    tags?: string[] | undefined;
    additionalGraph?: { [key: string]: string; } | undefined;
    siteName?: string | undefined;
    author?: string | undefined;
    publicationDate?: Date;
    isRecommended?: boolean;
    isPublic?: boolean;

    constructor(data?: IResourceApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.title = _data["title"];
            this.classification = _data["classification"];
            this.url = _data["url"];
            this.description = _data["description"];
            this.thumbnail = _data["thumbnail"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (_data["additionalGraph"]) {
                this.additionalGraph = {} as any;
                for (let key in _data["additionalGraph"]) {
                    if (_data["additionalGraph"].hasOwnProperty(key))
                        (<any>this.additionalGraph)![key] = _data["additionalGraph"][key];
                }
            }
            this.siteName = _data["siteName"];
            this.author = _data["author"];
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : <any>undefined;
            this.isRecommended = _data["isRecommended"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): ResourceApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["title"] = this.title;
        data["classification"] = this.classification;
        data["url"] = this.url;
        data["description"] = this.description;
        data["thumbnail"] = this.thumbnail;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (this.additionalGraph) {
            data["additionalGraph"] = {};
            for (let key in this.additionalGraph) {
                if (this.additionalGraph.hasOwnProperty(key))
                    (<any>data["additionalGraph"])[key] = this.additionalGraph[key];
            }
        }
        data["siteName"] = this.siteName;
        data["author"] = this.author;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : <any>undefined;
        data["isRecommended"] = this.isRecommended;
        data["isPublic"] = this.isPublic;
        return data; 
    }
}

export interface IResourceApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    title?: string | undefined;
    classification?: string | undefined;
    url?: string | undefined;
    description?: string | undefined;
    thumbnail?: string | undefined;
    tags?: string[] | undefined;
    additionalGraph?: { [key: string]: string; } | undefined;
    siteName?: string | undefined;
    author?: string | undefined;
    publicationDate?: Date;
    isRecommended?: boolean;
    isPublic?: boolean;
}

export class ResourceCreationAssignment implements IResourceCreationAssignment {
    grandParentId!: number;
    parentId!: number;

    constructor(data?: IResourceCreationAssignment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grandParentId = _data["grandParentId"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): ResourceCreationAssignment {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceCreationAssignment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grandParentId"] = this.grandParentId;
        data["parentId"] = this.parentId;
        return data; 
    }
}

export interface IResourceCreationAssignment {
    grandParentId: number;
    parentId: number;
}

export class ResourceCreationRequest implements IResourceCreationRequest {
    assignments!: ResourceCreationAssignment[];
    title!: string;
    url!: string;
    tags!: string[];
    publicationDate!: Date;
    isRecommended!: boolean;
    isPublic!: boolean;
    classification?: string | undefined;
    description?: string | undefined;
    thumbnail?: string | undefined;
    additionalGraph?: { [key: string]: string; } | undefined;
    siteName?: string | undefined;
    author?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IResourceCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.assignments) {
                this.assignments = [];
                for (let i = 0; i < data.assignments.length; i++) {
                    let item = data.assignments[i];
                    this.assignments[i] = item && !(<any>item).toJSON ? new ResourceCreationAssignment(item) : <ResourceCreationAssignment>item;
                }
            }
        }
        if (!data) {
            this.assignments = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(ResourceCreationAssignment.fromJS(item));
            }
            this.title = _data["title"];
            this.url = _data["url"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : <any>undefined;
            this.isRecommended = _data["isRecommended"];
            this.isPublic = _data["isPublic"];
            this.classification = _data["classification"];
            this.description = _data["description"];
            this.thumbnail = _data["thumbnail"];
            if (_data["additionalGraph"]) {
                this.additionalGraph = {} as any;
                for (let key in _data["additionalGraph"]) {
                    if (_data["additionalGraph"].hasOwnProperty(key))
                        (<any>this.additionalGraph)![key] = _data["additionalGraph"][key];
                }
            }
            this.siteName = _data["siteName"];
            this.author = _data["author"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): ResourceCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        data["title"] = this.title;
        data["url"] = this.url;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : <any>undefined;
        data["isRecommended"] = this.isRecommended;
        data["isPublic"] = this.isPublic;
        data["classification"] = this.classification;
        data["description"] = this.description;
        data["thumbnail"] = this.thumbnail;
        if (this.additionalGraph) {
            data["additionalGraph"] = {};
            for (let key in this.additionalGraph) {
                if (this.additionalGraph.hasOwnProperty(key))
                    (<any>data["additionalGraph"])[key] = this.additionalGraph[key];
            }
        }
        data["siteName"] = this.siteName;
        data["author"] = this.author;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IResourceCreationRequest {
    assignments: IResourceCreationAssignment[];
    title: string;
    url: string;
    tags: string[];
    publicationDate: Date;
    isRecommended: boolean;
    isPublic: boolean;
    classification?: string | undefined;
    description?: string | undefined;
    thumbnail?: string | undefined;
    additionalGraph?: { [key: string]: string; } | undefined;
    siteName?: string | undefined;
    author?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;
}

export class ResourceUpdateRequest implements IResourceUpdateRequest {
    assignments!: ResourceCreationAssignment[];
    title!: string;
    url!: string;
    tags!: string[];
    publicationDate!: Date;
    isRecommended!: boolean;
    isPublic!: boolean;
    classification?: string | undefined;
    description?: string | undefined;
    thumbnail?: string | undefined;
    additionalGraph?: { [key: string]: string; } | undefined;
    siteName?: string | undefined;
    author?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: IResourceUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.assignments) {
                this.assignments = [];
                for (let i = 0; i < data.assignments.length; i++) {
                    let item = data.assignments[i];
                    this.assignments[i] = item && !(<any>item).toJSON ? new ResourceCreationAssignment(item) : <ResourceCreationAssignment>item;
                }
            }
        }
        if (!data) {
            this.assignments = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["assignments"])) {
                this.assignments = [] as any;
                for (let item of _data["assignments"])
                    this.assignments!.push(ResourceCreationAssignment.fromJS(item));
            }
            this.title = _data["title"];
            this.url = _data["url"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : <any>undefined;
            this.isRecommended = _data["isRecommended"];
            this.isPublic = _data["isPublic"];
            this.classification = _data["classification"];
            this.description = _data["description"];
            this.thumbnail = _data["thumbnail"];
            if (_data["additionalGraph"]) {
                this.additionalGraph = {} as any;
                for (let key in _data["additionalGraph"]) {
                    if (_data["additionalGraph"].hasOwnProperty(key))
                        (<any>this.additionalGraph)![key] = _data["additionalGraph"][key];
                }
            }
            this.siteName = _data["siteName"];
            this.author = _data["author"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): ResourceUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResourceUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.assignments)) {
            data["assignments"] = [];
            for (let item of this.assignments)
                data["assignments"].push(item.toJSON());
        }
        data["title"] = this.title;
        data["url"] = this.url;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : <any>undefined;
        data["isRecommended"] = this.isRecommended;
        data["isPublic"] = this.isPublic;
        data["classification"] = this.classification;
        data["description"] = this.description;
        data["thumbnail"] = this.thumbnail;
        if (this.additionalGraph) {
            data["additionalGraph"] = {};
            for (let key in this.additionalGraph) {
                if (this.additionalGraph.hasOwnProperty(key))
                    (<any>data["additionalGraph"])[key] = this.additionalGraph[key];
            }
        }
        data["siteName"] = this.siteName;
        data["author"] = this.author;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface IResourceUpdateRequest {
    assignments: IResourceCreationAssignment[];
    title: string;
    url: string;
    tags: string[];
    publicationDate: Date;
    isRecommended: boolean;
    isPublic: boolean;
    classification?: string | undefined;
    description?: string | undefined;
    thumbnail?: string | undefined;
    additionalGraph?: { [key: string]: string; } | undefined;
    siteName?: string | undefined;
    author?: string | undefined;
    legacyKnowledgebaseId?: string | undefined;
}

export class SectionApiModel implements ISectionApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    name?: string | undefined;
    groupCount?: number;
    groups?: GroupApiModel[] | undefined;

    constructor(data?: ISectionApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            if (data.groups) {
                this.groups = [];
                for (let i = 0; i < data.groups.length; i++) {
                    let item = data.groups[i];
                    this.groups[i] = item && !(<any>item).toJSON ? new GroupApiModel(item) : <GroupApiModel>item;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
            this.name = _data["name"];
            this.groupCount = _data["groupCount"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupApiModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SectionApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SectionApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        data["name"] = this.name;
        data["groupCount"] = this.groupCount;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISectionApiModel {
    id?: number;
    legacyKnowledgebaseId?: string | undefined;
    name?: string | undefined;
    groupCount?: number;
    groups?: IGroupApiModel[] | undefined;
}

export class SectionCreationRequest implements ISectionCreationRequest {
    name!: string;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: ISectionCreationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): SectionCreationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SectionCreationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface ISectionCreationRequest {
    name: string;
    legacyKnowledgebaseId?: string | undefined;
}

export class SectionUpdateRequest implements ISectionUpdateRequest {
    newParentId!: number;
    name!: string;
    legacyKnowledgebaseId?: string | undefined;

    constructor(data?: ISectionUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newParentId = _data["newParentId"];
            this.name = _data["name"];
            this.legacyKnowledgebaseId = _data["legacyKnowledgebaseId"];
        }
    }

    static fromJS(data: any): SectionUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SectionUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newParentId"] = this.newParentId;
        data["name"] = this.name;
        data["legacyKnowledgebaseId"] = this.legacyKnowledgebaseId;
        return data; 
    }
}

export interface ISectionUpdateRequest {
    newParentId: number;
    name: string;
    legacyKnowledgebaseId?: string | undefined;
}

export class UrlVerificationRequest implements IUrlVerificationRequest {
    urlToVerify?: string | undefined;

    constructor(data?: IUrlVerificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.urlToVerify = _data["urlToVerify"];
        }
    }

    static fromJS(data: any): UrlVerificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UrlVerificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["urlToVerify"] = this.urlToVerify;
        return data; 
    }
}

export interface IUrlVerificationRequest {
    urlToVerify?: string | undefined;
}

export class VerificationResultApiModel implements IVerificationResultApiModel {
    resource?: ResourceApiModel;
    alreadySaved?: boolean;

    constructor(data?: IVerificationResultApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
            this.resource = data.resource && !(<any>data.resource).toJSON ? new ResourceApiModel(data.resource) : <ResourceApiModel>this.resource; 
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resource = _data["resource"] ? ResourceApiModel.fromJS(_data["resource"]) : <any>undefined;
            this.alreadySaved = _data["alreadySaved"];
        }
    }

    static fromJS(data: any): VerificationResultApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new VerificationResultApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resource"] = this.resource ? this.resource.toJSON() : <any>undefined;
        data["alreadySaved"] = this.alreadySaved;
        return data; 
    }
}

export interface IVerificationResultApiModel {
    resource?: IResourceApiModel;
    alreadySaved?: boolean;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}